import { useQuery } from "@tanstack/react-query";
import { featuresService } from "@/services/features.services";

export const useGetFeatures = () => {
	return useQuery({
		queryKey: ["features"],
		queryFn: () => {
			return featuresService.getFeatures();
		},
	});
};
